import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import { getGalleriesByUser } from "./galleires.api";
import { Gallery } from "@/types/galleryData";

interface GalleriesState {
    isLoading: boolean;
    error: string | null;
    galleries: Gallery[];
  }

const galleriesState: GalleriesState = {
    isLoading: false,
    error: null,
    galleries: [],
}


export const getGalleries = createAsyncThunk(
    "galleries/getGalleriesByUser",
    async(_, {rejectWithValue}) => {
        try {
            const resp = await getGalleriesByUser();
            return resp
        } catch (error) {
            console.log(error);
            return rejectWithValue(error.response?.data || error.msg)
        }
    }
)

const gallerySlice = createSlice({
    name: "Galleries",
    initialState: galleriesState,
    reducers: {
        getGalleries: () => {}
    },
    extraReducers: (builder) => {
        builder
            .addCase(getGalleries.pending, (state) => {
                state.isLoading = true;
                state.error = null;
            })
            .addCase(getGalleries.fulfilled, (state, action) => {
                state.isLoading = false;
                state.galleries = action.payload.data.galleries;
            })
            .addCase(getGalleries.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload as string;
            })
    }
})

export default gallerySlice.reducer;